// Frontend mirror of backend RBAC (server-side stays the source of truth).
export const ROLE_RANK = { admin: 4, manager: 3, mitarbeiter: 2, erfasser: 1, editor: 2, owner: 4 };

export const ROLE_LABELS = {
  admin: "Administrator",
  manager: "Manager",
  mitarbeiter: "Mitarbeiter",
  erfasser: "Erfasser",
  editor: "Mitarbeiter",
  owner: "Administrator",
};

export const ROLE_OPTIONS = [
  { value: "manager", label: "Manager" },
  { value: "mitarbeiter", label: "Mitarbeiter" },
  { value: "erfasser", label: "Erfasser" },
  { value: "admin", label: "Administrator" },
];

export const ROLE_DESCRIPTIONS = {
  admin: "Voller Zugriff – alles inkl. Benutzer & Einstellungen.",
  manager: "Veröffentlichen, löschen (Papierkorb), Anfragen.",
  mitarbeiter: "Erstellen, bearbeiten, veröffentlichen.",
  erfasser: "Nur Fotos, KI & Entwürfe – kann nichts veröffentlichen oder löschen.",
};

const PERM_RANK = {
  "item:create": 1,
  "item:edit": 1,
  "item:publish": 2,
  "item:delete": 3,
  "item:restore": 3,
  "item:purge": 4,
  "inquiry:manage": 2,
  "activity:view": 3,
  "user:manage": 4,
  "settings:manage": 4,
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || "—";

export const can = (user, perm) => {
  const rank = ROLE_RANK[user?.role] || 0;
  return rank >= (PERM_RANK[perm] ?? 99);
};
